// Fixes a real bug: BottomSheet/SuccessOverlay used to render as
// descendants of the scrollable page panel. Their `position:
// absolute` was then relative to that scrolling panel, so
// scrolling the page while a sheet was open dragged the sheet
// off-screen with it.
//
// The fix is to always render overlay content into a single node
// that lives at the app-shell level (a sibling of the scrollable
// panels, inside the non-scrolling `.app` root) — regardless of
// which page/component actually owns the open/close state. This
// provider exposes that DOM node so any component can portal into
// it with `useOverlayPortalNode()`.

import { createContext, useContext, useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';

const OverlayPortalContext = createContext<HTMLDivElement | null>(null);

export function OverlayPortalProvider({ children }: { children: ReactNode }) {
  const rootRef = useRef<HTMLDivElement>(null);
  const [node, setNode] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    setNode(rootRef.current);
  }, []);

  return (
    <OverlayPortalContext.Provider value={node}>
      {children}
      <div ref={rootRef} />
    </OverlayPortalContext.Provider>
  );
}

export function useOverlayPortalNode(): HTMLDivElement | null {
  return useContext(OverlayPortalContext);
}
